module.exports = __webpack_public_path__ + "static/doug_hutchinson-ab1218a40dfe463279aa855f7791df64.jpg";